import { createContext } from "react";
import { IAudioContext } from "./audio-context.types";

export const defaultAudioContext: IAudioContext = {
    currentTime: 0,
    duration: 0,
    error: null,
    isPlaying: false,
    isLoading: true,
    isMuted: false,
    playbackRate: 1,
    volume: 1,
    url: null,
    audioRef: null,
};

export const AudioContext = createContext<IAudioContext>(defaultAudioContext);
